import { render, staticRenderFns } from "./Gff.vue?vue&type=template&id=0a0cb162&scoped=true"
import script from "./Gff.vue?vue&type=script&lang=js"
export * from "./Gff.vue?vue&type=script&lang=js"
import style0 from "./Gff.vue?vue&type=style&index=0&id=0a0cb162&prod&lang=scss&scoped=true"
import style1 from "./Gff.vue?vue&type=style&index=1&id=0a0cb162&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0cb162",
  null
  
)

export default component.exports